import { FormDialogConfig } from '@aibees/shared/components';
import { AuthUser, Nil } from '@aibees/shared/definition';
import { yup } from '@aibees/shared/utils';
import { useMemo } from 'react';

export function useConfig(defaultValue: Nil<AuthUser>): FormDialogConfig {
  const scheme = useMemo(() => {
    return yup
      .object()
      .shape({
        firstName: yup
          .string()
          .required('First Name is required')
          .max(50, 'Maximum 50 characters allowed'),
        lastName: yup
          .string()
          .required('Last Name is required')
          .max(50, 'Maximum 50 characters allowed'),
        attributes: yup.object().shape({
          title: yup
            .string()
            .nullable()
            .transform((value) => {
              if (value === '' || value === undefined) {
                return null;
              }
              return value;
            })
            .max(50, 'Maximum 50 characters allowed'),
        }),
      })
      .test(
        'is-any-changed',
        'At least one field must be different from the initial value',
        (values) => {
          if (!defaultValue) return true;

          const currentTitle = values.attributes?.title || null;
          const defaultTitle = defaultValue.attributes?.title || null;

          return (
            values.firstName !== defaultValue.firstName ||
            values.lastName !== defaultValue.lastName ||
            currentTitle !== defaultTitle
          );
        }
      );
  }, [defaultValue]);

  const config = useMemo<FormDialogConfig>(() => {
    return {
      scheme,
    };
  }, [scheme]);

  return config;
}
